import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import api from '../../api';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { pdfjs } from 'react-pdf';
import './Certificates.css';

function CertificatesId() {
  const { certificateId } = useParams();
  const [pdfUrl, setPdfUrl] = useState('');
  const [pdfFile, setPdfFile] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCertificate = async () => {
      try {
        const response = await axios.get(api.getPublicCertificate(certificateId));

        if (response.status === 200 && response.data.filePath) {
          const url = api.getCertificateFileUrl(response.data.filePath);
          setPdfUrl(url);

          const pdfData = await axios.get(url, { responseType: 'arraybuffer' });
          setPdfFile(pdfData.data);
          setError(null);
        } else {
          setError('Certificate not found or invalid response');
        }
      } catch (error) {
        console.error('Error fetching certificate:', error);
        setError('No Certificate found');
      }
    };

    fetchCertificate();
  }, [certificateId]);

  const handleDownload = () => {
    if (pdfFile) {
      const blob = new Blob([pdfFile], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `certificate-${certificateId}.pdf`;
      link.click();
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="pcv-container">
      <div className="pcv-header">
        <h1 className="pcv-title">Certificate </h1>
        <div className="pcv-button-group">
                  
          {pdfFile && (
            <button onClick={handleDownload} className="pcv-button pcv-button-download">
                            Download PDF
            </button>
          )}
          <button onClick={handleGoBack} className="pcv-button pcv-button-back">
                        Go Back
          </button>
        </div>
      </div>

      <div className="pcv-viewer-container">
        {error ? (
          <div className="pcv-error-container">
            <p className="pcv-error-message">{error}</p>
          </div>
        ) : pdfFile ? (
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">

            <Viewer fileUrl={pdfUrl} />
          </Worker>
        ) : (
          <div className="pcv-loading-container">
            <p className="pcv-loading-message">Loading PDF...</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default CertificatesId;